import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    loggedInUser: null, // You can initialize this with the user object or any other data you need.
  },
  reducers: {
    setLoggedInUser: (state, action) => {
      state.loggedInUser = action.payload;
    },
  },
});

export const { setLoggedInUser } = userSlice.actions;
export const selectLoggedInUser = (state) => state.user.loggedInUser;
export default userSlice.reducer;